module.exports = __webpack_public_path__ + "static/Demystifying-economics-header-c94e84178a2c8de96e899d3dc5cfeb16.jpg";